import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { todayISO } from "@/lib/apiClient";

const pad = (n) => String(n).padStart(2, "0");
const iso = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

export const PRESETS = {
  today: () => { const t = todayISO(); return { start: t, end: t }; },
  week: () => { const d = new Date(); const s = new Date(d); s.setDate(d.getDate() - 6); return { start: iso(s), end: iso(d) }; },
  month: () => { const d = new Date(); return { start: iso(new Date(d.getFullYear(), d.getMonth(), 1)), end: iso(d) }; },
  year: () => { const d = new Date(); return { start: `${d.getFullYear()}-01-01`, end: iso(d) }; },
  all: () => ({ start: "", end: "" }),
};

const LABELS = [["today", "Bugün"], ["week", "Son 7 Gün"], ["month", "Bu Ay"], ["year", "Bu Yıl"], ["all", "Tümü"]];

export function DateRangeFilter({ range, onChange }) {
  return (
    <div className="flex flex-wrap items-end gap-3 rounded-xl border border-border bg-card p-4" data-testid="date-range-filter">
      <div>
        <p className="mb-1 text-[11px] uppercase tracking-wide text-muted-foreground">Başlangıç</p>
        <Input data-testid="range-start" type="date" value={range.start} max={range.end || undefined}
          onChange={(e) => onChange({ ...range, start: e.target.value })} className="w-40" />
      </div>
      <div>
        <p className="mb-1 text-[11px] uppercase tracking-wide text-muted-foreground">Bitiş</p>
        <Input data-testid="range-end" type="date" value={range.end} min={range.start || undefined}
          onChange={(e) => onChange({ ...range, end: e.target.value })} className="w-40" />
      </div>
      <div className="flex flex-wrap gap-1.5">
        {LABELS.map(([k, l]) => (
          <Button key={k} size="sm" variant="secondary" data-testid={`range-preset-${k}`} onClick={() => onChange(PRESETS[k]())}>{l}</Button>
        ))}
      </div>
    </div>
  );
}
